import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Item as dxListItem, ItemClickEvent } from 'devextreme/ui/list';
import { ValueChangedEvent as NumberBoxValueChangeEvent } from 'devextreme/ui/number_box';

import { NextPimField } from 'app/Model/Catalog/NextPimField';
import { TemplateService } from 'app/Services/template.service';
import { TemplateItem } from 'app/Model/Catalog/TemplateItem';
import { comparePimFields, fillLastKey, isNextPimField, parsePimField } from 'app/Services/templateItemHelpers';
import { TemplateItemTemplate } from '../../Model/Catalog/TemplateItemTemplate';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import {TemplateFieldsService} from "../../Services/templateFields.service";
import {LoginService} from "../../Services/login.service";

@Component({
    selector: 'np-advanced-template-udx',
    templateUrl: './advanced-template-udx.component.html',
    standalone: false
})
export class AdvancedTemplateUdxComponent {
  @Input() templateItem!: TemplateItem;
  @Input() pimField!: NextPimField;

  @Output() onUpdate = new EventEmitter<void>();

  fieldList: TemplateItemTemplate[] = this.fieldService.udxFields;

  constructor(private templateService: TemplateService, private fieldService: TemplateFieldsService, private loginService: LoginService) {
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  onFieldItemClick(event: ItemClickEvent<TemplateItemTemplate>) {
    this.pimField.field = event.itemData.field;
    this.update();
  }

  onOrderChanged() {
    this.update();
  }

  update() {
    const { field, systemKey, elementKey } = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key);
    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }
    this.templateService.getHeadline(field, elementKey, systemKey, this.loginService.currentCustomer.id).subscribe((headline) => {
      fillLastKey(this.templateItem, headline.value);
      this.onUpdate.emit();
    });
  }

}
